import React from "react";
import Button from "../common/Buttons"
import {Text, TextButtonBoxContainer} from "./styled";

type TextButtonBoxProps = {
	text?:string,
	buttonLabel?:string,
  buttonWidth?:string
}

const defaultProps: TextButtonBoxProps = {
  text:"",
  buttonLabel: ""
};

function TextButtonBox({ text, buttonLabel, buttonWidth }: TextButtonBoxProps) {
  
  return (
    <TextButtonBoxContainer>
        <Text>
            {text}
        </Text>
        <Button rounded label={buttonLabel} width={buttonWidth} />
    </TextButtonBoxContainer>
  );
}

TextButtonBox.defaultProps = defaultProps;

export { TextButtonBox };
